import { BlockComponentFactory } from '../BlockFactory'
import Typography from 'antd/lib/typography'
import { ParagraphBlockProps } from './block-props.types'
import { LabelBlock } from './LabelBlock'
import { LABEL_BOLD_FONT_STYLE, LABEL_FONT_STYLE } from '../../constants'
import { toCSSSize } from './block-utils'

const { Paragraph: AntParagraph } = Typography

export const ParagraphBlockComponent =
    BlockComponentFactory.createBlockComponent<ParagraphBlockProps>(props => {
        const {
            label,
            value,
            infoText,
            width,
            height,
            alignment = 'left',
            visibility = 'visible',
            disabled = false,
            style,
        } = props

        const containerStyle: React.CSSProperties = {
            ...style,
            display: visibility === 'hidden' ? 'none' : 'flex',
            flexDirection: 'column',
            gap: '8px',
            width: toCSSSize(width) || '100%',
            height: toCSSSize(height) || 'auto',
            opacity: disabled ? 0.5 : 1,
        }

        const paragraphStyle: React.CSSProperties = {
            textAlign: alignment,
            margin: 0,
            ...LABEL_FONT_STYLE,
        }

        return (
            <div style={containerStyle}>
                <LabelBlock label={label} infoText={infoText} labelStyle={LABEL_BOLD_FONT_STYLE} />
                <AntParagraph style={paragraphStyle}>{value}</AntParagraph>
            </div>
        )
    })
